import { motion } from "framer-motion";
import { useEffect, useState } from "react";
import { urlFor, client } from "../../client";
import "./Project.scss";

const EachProject = ({
  imageurl,
  name,
  stack,
  visiturl,
  codeurl,
  setCursorVariant,
}) => {
  const objectEnter = () => {
    setCursorVariant("diff");
  };
  const objectLeave = () => {
    setCursorVariant("default");
  };
  return (
    <div className="gallery-item-wrapper">
      <div className="gallery-item">
        <a
          href={visiturl === "no" ? codeurl : visiturl}
          target="_blank"
          rel="noreferrer"
        >
          <div
            className="gallery-item-image"
            style={{ backgroundImage: `url(${urlFor(imageurl)})` }}
            data-scroll
            data-scroll-speed="5"
            onMouseEnter={objectEnter}
            onMouseLeave={objectLeave}
          ></div>
        </a>
        <div className="gallery-item-info" data-scroll data-scroll-speed="2">
          <h1 className="gallery-info-title">{name}</h1>
          <h6 className="gallery-info-subtitle">app</h6>
          <p className="gallery-info-category">{stack.join(", ")}</p>
          <div className="gallery-btn">
            <a href={codeurl} target="_blank" rel="noreferrer">
              <motion.button
                className="btn1"
                whileHover={{
                  rotateZ: [0, -15, 10, -10, 6, -4, 0],
                }}
                whileTap={{ scale: 0.9 }}
              >
                view code
              </motion.button>
            </a>
            <a
              href={visiturl === "no" ? codeurl : visiturl}
              target="_blank"
              rel="noreferrer"
            >
              <motion.button
                className="btn2"
                whileHover={{
                  rotateZ: [0, -15, 10, -10, 6, -4, 0],
                }}
                whileTap={{ scale: 0.9 }}
              >
                {visiturl !== "no" ? (
                  <span>visit</span>
                ) : (
                  <span>Under development</span>
                )}
              </motion.button>
            </a>
          </div>
        </div>
        <div />
      </div>
    </div>
  );
};

const Project = ({ setCursorVariant }) => {
  const [projects, setProjects] = useState([]);

  useEffect(() => {
    const query = '*[_type == "projects"]';
    client.fetch(query).then((data) => setProjects(data));
  }, []);
  return (
    <section className="gallery-wrap" data-scroll-section id="project">
      <div className="project-heading">
        <div className="project-headline-group">
          <div
            className="project-outline diff"
            data-scroll
            data-scroll-speed="1"
          >
            PROJECTS
          </div>
          <div className="project-text" data-scroll data-scroll-speed="2">
            PROJECTS
          </div>
          <div className="project-outline" data-scroll data-scroll-speed="3">
            PROJECTS
          </div>
        </div>
      </div>
      <div className="gallery">
        {projects.map((item, index) => (
          <EachProject
            setCursorVariant={setCursorVariant}
            key={index}
            index={index}
            {...item}
          />
        ))}
      </div>
    </section>
  );
};

export default Project;
